import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  CircularProgress,
  FormControl,
  Typography,
} from "@material-ui/core";
import LanguageHelper from "../../../helpers/LanguageHelper";
import Request from "../../../helpers/Request";
import TableEntryModal from "../../../components/Modal/TableEntryModal";
import showSnackbar from "../../../components/Utils/showSnackbar";
import { modalFormStyles } from "../../../assets/styles/tableContainer";
import { entryUrl } from "./IsgProfessionalModal";

const useStyles = makeStyles((theme) => ({
  ...modalFormStyles(theme),
  question: {
    marginBottom: "1vw",
  },
}));

export default function DeleteModal({
  modal,
  setModal,
  row,
  setSnackbar,
  setSnackbarMessage,
  setSeverity,
  tableRef,
  reloadLimit,
}) {
  const classes = useStyles();
  const language = LanguageHelper.getLanguage();
  const [loading, setLoading] = React.useState(false);

  const handleCloseModal = () => {
    setModal(false);
  };

  const deleteEntry = async () => {
    setLoading(true);
    const resp = await Request(
      "delete",
      entryUrl(row.documentType, row.tcNo),
      null
    );
    showSnackbar(
      resp,
      setSeverity,
      setSnackbarMessage,
      setSnackbar,
      language.etc.deleted,
      tableRef
    );
    setLoading(false);
    if (resp?.status === 200) {
      reloadLimit();
      handleCloseModal();
    }
  };

  return (
    <TableEntryModal modal={modal} handleCloseModal={handleCloseModal}>
      <FormControl noValidate className={classes.formControl}>
        <Typography className={classes.question}>
          {row
            ? row.firstName +
              " " +
              row.lastName +
              " (" +
              row.tcNo +
              ") kaydını silmek istediğinize emin misiniz?"
            : ""}
        </Typography>
        <div style={{ textAlign: "center" }}>
          {loading ? (
            <CircularProgress color="secondary" />
          ) : (
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              onClick={deleteEntry}
              className={classes.submit}
            >
              {language.etc.delete}
            </Button>
          )}
        </div>
      </FormControl>
    </TableEntryModal>
  );
}
